import { catchError, map, mergeMap, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatFacades from "../../internal";

@Injectable()
export class MediaAuthorFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  mediaSearch$ = this.store.select(FlatStates.MediaAuthorState.mediaSearch$);
  mediaResultMedias$ = this.store.select(FlatStates.MediaAuthorState.mediaResultMedias$);

  //</editor-fold>
  
  //<editor-fold desc="Lazy Selectors">
  
  mediaById$ = (id: string) => this.store.select(FlatStates.MediaEntityState.entity$).pipe(map(filterFn => filterFn(id)));
  mediaByIds$ = (ids: string[]) => this.store.select(FlatStates.MediaEntityState.entitiesByIds$).pipe(map(filterFn => filterFn(ids)));
  mediaUsedInById$ = (id: string) => this.store.select(FlatStates.MediaAuthorState.mediaUsedInById$).pipe(map(filterFn => filterFn(id)));
  
  //</editor-fold>
  
  //<editor-fold desc="Snapshot Selectors">
  
  snapshot_mediaUsedIn = () => this.store.selectSnapshot(FlatStates.MediaAuthorState.mediaUsedIn$);
  
  //</editor-fold>

  //<editor-fold desc="Requests">

  requestGetMedia(ids: string[]) {
    return this.store.dispatch(new FlatActions.MediaAuthorActions.GetMediasByIds(ids));
  }

  requestUpdateMedia(media: FlatModels.MediaEntityModels.Media) {
    return this.store.dispatch(new FlatActions.MediaEntityActions.UpdateEntity(media));
  }
  
  requestRearrangeMediaCopyrights(media: FlatModels.MediaEntityModels.MediaEntityType,
                                  mediaCopyrights: FlatModels.MediaEntityModels.MediaCopyright[]) {
    return this.store.dispatch(new FlatActions.MediaEntityActions.RearrangeMediaCopyrights(media, mediaCopyrights));
  }

  requestRemoveMedia(ids: string[]) {
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.saving)).pipe(
      mergeMap(() =>
        FlatFacades.MediaEntityFacade.removeMedias(this.store, ids)
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));

        return throwError(() => {
          return result;
        });
      }),
    );
  }

  requestUpdateWatermark(media: FlatModels.MediaEntityModels.Media,
                         position: FlatModels.MediaEntityModels.CopyrightPosition) {
    return this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.saving)).pipe(
      mergeMap(() =>
        this.store.dispatch(new FlatActions.MediaAuthorActions.AddWatermark(media, position))
      ),
      mergeMap(() =>
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none))
      ),
      catchError(result => {
        this.store.dispatch(new FlatActions.HistoryControlActions.SetBlockUiType(FlatModels.EntityControlModels.BlockUiType.enum.none));

        return throwError(() => {
          return result;
        });
      }),
    );
  }

  //</editor-fold>

}
